<template>
  <div class="m-15" v-if="items.length > 0">
    <b-table
      striped
      bordered
      :busy="isBusy"
      hover
      :items="items"
      :fields="fields"
      @row-clicked="rowHandler"
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <strong>Carregando...</strong>
      </div>
    </b-table>
  </div>
</template>

<style>
.m-15 {
  margin: 15px;
}
</style>


<script>
import axios from "axios";
import * as config from "@/config.json";
import moment from "moment";
import tz from "moment-timezone";

export default {
  name: "vincularpromocao",
  components: {},
  data: _ => {
    return {
      isBusy: false,
      items: [],
      fields: [
        "data_inicial",
        "data_final",
        "data_sorteio",
        "descricao_sorteio",
        "descricao_premios"
      ]
    };
  },
  methods: {
    rowHandler(record, index, event) {
      localStorage.setItem("selecionado", record.id_local);
      localStorage.setItem(
        "data_inicial",
        moment(record.data_inicial_padrao).format()
      );
      localStorage.setItem(
        "data_final",
        moment(record.data_final_padrao).format()
      );
      this.$emit("can-continue", { value: true });
    }
  },
  async beforeMount() {
    this.isBusy = true;
    const options = { title: "Algo deu errado...", size: "sm" };
    await axios
      .get(
        `${config.default.servidor}/gerencial/sorteios/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        // console.log(response.data.data);
        if (response.data.data.length > 0) {
          this.items = response.data.data;
          console.log(this.items);
          this.isLoading = false;
          this.isBusy = false;
        } else {
          this.$dialogs
            .alert("Não encontramos promoções no seu sistema Accesys.", options)
            .then(res => {
              this.$router.go(-1);
            });
        }
      })
      .catch(e => {
        console.error(e);
        this.isBusy = false;
        this.$dialogs
          .alert("Não encontramos promoções no seu sistema Accesys.", options)
          .then(res => {
            console.log(res); // {ok: true|false|undefined}
          });
      });
  },
  mounted() {
    this.$emit("update:title", "titulo");
  }
};
</script>

